"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _clsx = _interopRequireDefault(require("clsx"));

var _styles = require("@material-ui/core/styles");

var _pickReactKnownProp = require("pick-react-known-prop");

var _reactHtmlParser = _interopRequireDefault(require("react-html-parser"));

var _ProductImage = _interopRequireDefault(require("@sprinx/react-com/ProductImage"));

var _last = _interopRequireDefault(require("lodash/fp/last"));

var _useProductPackageContent = _interopRequireDefault(require("./useProductPackageContent"));

var useStyles = (0, _styles.makeStyles)(function (theme) {
  var _content;

  return {
    root: {
      display: 'flex',
      justifyContent: 'center',
      flexBasis: '100%',
      flexGrow: 1,
      width: '100%',
      paddingTop: theme.spacing(2),
      paddingBottom: theme.spacing(2)
    },
    content: (_content = {
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'flex-start',
      width: '100%',
      flexWrap: 'wrap'
    }, (0, _defineProperty2.default)(_content, theme.breakpoints.up('md'), {
      flexWrap: 'nowrap'
    }), (0, _defineProperty2.default)(_content, '& p', (0, _defineProperty2.default)({
      paddingRight: 0,
      margin: 0,
      paddingBottom: theme.spacing(3)
    }, theme.breakpoints.up('md'), {
      paddingRight: theme.spacing(4),
      paddingBottom: 0
    })), _content),
    htmlContent: {
      minWidth: 300
    },
    image: {}
  };
}, {
  name: 'ProductDetailPackageContent'
});

function ProductDetailPackageContent(_ref) {
  var pClasses = _ref.classes,
      className = _ref.className,
      product = _ref.product,
      rest = (0, _objectWithoutProperties2.default)(_ref, ["classes", "className", "product"]);
  var classes = useStyles({
    classes: pClasses
  });

  var _useProductPackageCon = (0, _useProductPackageContent.default)(product.id),
      body = _useProductPackageCon.body;

  var image = product.image,
      media = product.media;
  var img = ((0, _last.default)((media || []).filter(function (m) {
    return m.type === 'image';
  })) || {}).src || image;
  return /*#__PURE__*/_react.default.createElement("div", (0, _extends2.default)({}, (0, _pickReactKnownProp.pickHTMLProps)(rest), {
    className: (0, _clsx.default)(classes.root, className)
  }), /*#__PURE__*/_react.default.createElement("div", {
    className: classes.content
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: classes.htmlContent
  }, body && (0, _reactHtmlParser.default)(body)), img && /*#__PURE__*/_react.default.createElement(_ProductImage.default, {
    className: classes.image,
    size: "big",
    type: "image",
    src: img
  })));
}

process.env.NODE_ENV !== "production" ? ProductDetailPackageContent.propTypes = {
  classes: _propTypes.default.shape({
    content: _propTypes.default.string,
    htmlContent: _propTypes.default.string,
    image: _propTypes.default.string,
    root: _propTypes.default.string
  }),
  className: _propTypes.default.string,
  product: _propTypes.default.shape({
    id: _propTypes.default.string,
    image: _propTypes.default.arrayOf(_propTypes.default.arrayOf(_propTypes.default.string)),
    media: _propTypes.default.arrayOf(_propTypes.default.shape({}))
  }).isRequired
} : void 0;
ProductDetailPackageContent.defaultProps = {
  classes: undefined,
  className: undefined
};
var _default = ProductDetailPackageContent;
exports.default = _default;